import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useRef, Fragment } from "react";
import { Box } from "../Box/Box.mjs";
import { Field } from "../private/Field/Field.mjs";
import { ClearField } from "../private/Field/ClearField.mjs";
import { ActionField } from "../private/Field/ActionField.mjs";
import { getCharacterLimitStatus } from "../private/Field/getCharacterLimitStatus.mjs";
const validTypes = {
  text: "text",
  password: "password",
  email: "email",
  search: "search",
  number: "number",
  tel: "tel",
  url: "url"
};
const defaultInputModesForType = {
  text: "text",
  password: "text",
  email: "email",
  search: "search",
  number: "numeric",
  tel: "tel",
  url: "url"
};
const TextField = forwardRef(
  ({
    value,
    type = "text",
    onChange,
    onKeyDown,
    onBlur,
    onFocus,
    onClear,
    onAction,
    characterLimit,
    maxLength,
    id,
    clearLabel,
    actionIcon,
    actionLabel,
    inputMode,
    step,
    ...restProps
  }, forwardedRef) => {
    const defaultRef = useRef(null);
    const inputRef = forwardedRef || defaultRef;
    const clearable = Boolean(
      typeof onClear !== "undefined" && !restProps.disabled && typeof value === "string" && value.length > 0
    );
    return /* @__PURE__ */ jsx(
      Field,
      {
        ...restProps,
        id,
        value,
        labelId: void 0,
        secondaryMessage: characterLimit ? getCharacterLimitStatus({
          value,
          characterLimit
        }) : null,
        secondaryIcon: onClear ? /* @__PURE__ */ jsx(
          ClearField,
          {
            id: `${id}-clear`,
            hide: !clearable,
            onClear,
            label: clearLabel,
            inputRef
          }
        ) : onAction && actionIcon ? /* @__PURE__ */ jsx(
          ActionField,
          {
            id: `${id}-action`,
            onAction,
            icon: actionIcon,
            label: actionLabel
          }
        ) : null,
        children: (overlays, fieldProps, icon, secondaryIcon, prefix) => /* @__PURE__ */ jsxs(Fragment, { children: [
          icon,
          prefix,
          /* @__PURE__ */ jsx(
            Box,
            {
              component: "input",
              maxLength,
              type: validTypes[type],
              value,
              onKeyDown,
              onChange,
              onFocus,
              onBlur,
              ...fieldProps,
              inputMode: inputMode || defaultInputModesForType[type],
              step,
              ref: inputRef
            }
          ),
          overlays,
          secondaryIcon
        ] })
      }
    );
  }
);
TextField.displayName = "TextField";
export {
  TextField
};
